var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contacts" },
    [
      _c("div", { staticClass: "contacts__search" }, [
        _c(
          "div",
          { staticClass: "contacts__search-item" },
          [
            _c("z-input", {
              attrs: { name: "", placeholder: "Поиск" },
              model: {
                value: _vm.input,
                callback: function ($$v) {
                  _vm.input = $$v
                },
                expression: "input",
              },
            }),
            _vm._v(" "),
            _c("z-icon", {
              attrs: {
                name: "magnifying_glass",
                dir: "top",
                width: "24",
                height: "24",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isFiltersChanged,
              expression: "isFiltersChanged",
            },
          ],
        },
        [
          _c(
            "z-caption",
            { staticClass: "contacts__count", attrs: { tag: "p", size: "xs" } },
            [
              _vm._v(
                "\n            Всего: " +
                  _vm._s(_vm.filteredContacts.length) +
                  " "
              ),
              _c("br"),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.filteredContacts, function (contact, idx) {
            return _c(
              "z-contact-card",
              {
                key: idx,
                attrs: {
                  horizontal: "",
                  title: contact.name,
                  subtitle: contact.speciality,
                  phone: contact.phones,
                  email: [
                    {
                      value: contact.email,
                    },
                  ],
                },
              },
              [
                contact.description
                  ? _c("p", [
                      _c("span", {
                        staticClass: "u-medium",
                        domProps: {
                          innerHTML: _vm._s(contact.descriptionTitle),
                        },
                      }),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(contact.description) },
                      }),
                    ])
                  : _vm._e(),
              ]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "z-accordion",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isFiltersChanged,
              expression: "!isFiltersChanged",
            },
          ],
        },
        _vm._l(_vm.data, function (item, index) {
          return _c("z-accordion-item", {
            key: index,
            attrs: { id: item.id },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(item.title) },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "body",
                  fn: function () {
                    return _vm._l(item.contacts, function (contact, idx) {
                      return _c(
                        "z-contact-card",
                        {
                          key: idx,
                          attrs: {
                            horizontal: "",
                            title: contact.name,
                            subtitle: contact.speciality,
                            phone: contact.phones,
                            email: [
                              {
                                value: contact.email,
                              },
                            ],
                          },
                        },
                        [
                          contact.description
                            ? _c("p", [
                                _c("span", {
                                  staticClass: "u-medium",
                                  domProps: {
                                    innerHTML: _vm._s(contact.descriptionTitle),
                                  },
                                }),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(contact.description),
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ]
                      )
                    })
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }